// WIP
import React, { useState } from 'react';

import PropTypes from 'prop-types';
import SearchIcon from 'react-icons/lib/fa/search';
import { withRouter } from 'react-router';

import {
    FadeInOutContainer,
    FadeInOut,
} from 'wanderu-animations';
import {
    Button,
    Section,
    Typography,
    ScheduleList,
} from 'wanderu-components';
import {
    i18nMoment,
    localize,
} from 'wanderu-i18n';
import {
    range,
    scrollToHash,
} from 'wanderu-utils';

import Events from './events/ScheduleContainerEvents';

import styles from './ScheduleContainer.scss';

const SCHEDULE_NUM = 5;
const DAYS_TO_SHOW = 7;

const propTypes = {
    departDate: PropTypes.string.isRequired,
    language: PropTypes.string,
    namespace: PropTypes.string.isRequired,
    schedule: PropTypes.arrayOf(PropTypes.object),
    t: PropTypes.func.isRequired,
};
const defaultProps = {
    language: '',
    schedule: [],
};

function getFeaturedDates() {
    return range(DAYS_TO_SHOW).reduce((obj, item, index) => {
        const daysToAdd = index + 1;
        const upcomingDate = i18nMoment().add(daysToAdd, 'days').format('YYYY-MM-DD');

        return {
            ...obj,
            [upcomingDate]: '',
        };
    }, {});
}

function ScheduleContainer(props) {
    const {
        departDate,
        language,
        namespace,
        schedule,
        t,
    } = props;

    const [numSchedules, setSchedulesNum] = useState(SCHEDULE_NUM);
    const [fullSchedules, showFullSchedules] = useState(false);

    const dates = getFeaturedDates();
    const defaultDate = Object.keys(dates)[0];

    if (!language && departDate === defaultDate && !schedule.length) {
        return null;
    }

    function trackEvent(showBoolean) {
        Events.scheduleSelected({
            date: departDate,
            showBoolean,
        });
    }

    function showSchedules() {
        trackEvent(fullSchedules);
        if (numSchedules !== SCHEDULE_NUM) {
            setSchedulesNum(SCHEDULE_NUM);
            showFullSchedules(false);
            scrollToHash('upcoming-trips-section', { duration: 600 });
        } else {
            setSchedulesNum(schedule.length);
            showFullSchedules(true);
        }
    }

    return (
        <Section
            classes={{ content: styles.container }}
            id="upcoming-trips-section"
        >
            <Typography
                align="center"
                variant="h2"
            >
                {t(`${namespace}:timeTableTitle`)}
            </Typography>
            {/* TODO Schedule Days Filter */}
            <FadeInOutContainer>
                <FadeInOut
                    className={styles.tripTableFade}
                    key={departDate}
                    unmountOnExit
                >
                    <ScheduleList scheduleResponse={schedule.slice(0, numSchedules)} />
                    {!schedule.length && (
                        <div className={styles.notFound}>
                            <SearchIcon className={styles.searchIcon} />
                            <span className={styles.notFoundText}>
                                {t(`${namespace}:timeTableNotFound`)}
                            </span>
                        </div>
                    )}
                    {schedule.length > SCHEDULE_NUM
                        ? (
                            <Button
                                className={styles.searchButton}
                                label={t(`${namespace}:timeTableSeeMore`)}
                                onClick={showSchedules}
                            >
                                {fullSchedules
                                    ? t(`${namespace}:timeTableSeeLess`)
                                    : t(`${namespace}:timeTableSeeMore`)}
                            </Button>
                        )
                        : null}
                </FadeInOut>
            </FadeInOutContainer>
        </Section>
    );
}

ScheduleContainer.propTypes = propTypes;
ScheduleContainer.defaultProps = defaultProps;

export { ScheduleContainer };
export default withRouter(localize(ScheduleContainer));
